/**
 * „Płatność” of a ZK (migration 215, decision
 * docs/decisions/2026-10-27-platnosc-zk-proforma-faktoring.md). The rule lives
 * in backend `utils/orderPaymentMode.js`; this mirror only reads the value and
 * names it. Nothing here blocks a step: statuses stay informational (WP3).
 */
export type OrderPaymentMode = 'TERM' | 'PREPAYMENT' | 'FACTORING';

export const ORDER_PAYMENT_MODES: readonly OrderPaymentMode[] = ['TERM', 'PREPAYMENT', 'FACTORING'];

export const DEFAULT_PREPAYMENT_PERCENT = 100;

export function normalizeOrderPaymentMode(value: unknown): OrderPaymentMode {
  return value === 'PREPAYMENT' || value === 'FACTORING' ? value : 'TERM';
}

/** 0 < percent <= 100, else null (an unloaded or redacted value is not 100 %). */
export function normalizePrepaymentPercent(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null;
  const percent = Number(value);
  return Number.isFinite(percent) && percent > 0 && percent <= 100 ? percent : null;
}

/** „30 %” / „12,5 %”. */
export function formatPrepaymentPercent(percent: number): string {
  return `${percent.toLocaleString('pl-PL', { maximumFractionDigits: 2 })} %`;
}

/**
 * „Czeka na wpłatę z proformy” (Zamówienia list): a prepaid ZK still in Szkic
 * or Oferta whose proforma payment is not recorded. Only for a reader of
 * customer payments: without the day a paid ZK would look unpaid (the list
 * hides the view from other roles).
 */
export function isOrderAwaitingPrepayment(order: { paymentMode?: string | null; status?: string | null; prepaymentPaidAt?: string | null }): boolean {
  return order.paymentMode === 'PREPAYMENT'
    && (order.status === 'NEW_INQUIRY' || order.status === 'QUOTE_SENT')
    && !order.prepaymentPaidAt;
}
